import { useCallback, useEffect } from 'react';

// local imports
import { CustomerService } from 'app/services';
import useDataApi from '../../use-data-api';
import { FormatUtils, Mapper } from 'app/utils';

const useCustomerDetailService = customerId => {
  const [service, setService] = useDataApi();

  const fetchData = useCallback(async () => {
    // ticket topics
    const customerDetail = await CustomerService.getCustomerDetail(customerId);
    const customerDetailData = customerDetail?.data?.data;

    const { telephone, gender, language, ...rest } = customerDetailData;

    return {
      telephone: FormatUtils.formatPhoneNumber(telephone),
      gender: Mapper.mapGenderInfo(gender?.id),
      language: Mapper.mapLanguageInfo(language?.id),
      ...rest
    };
  }, [customerId]);

  useEffect(() => setService(() => fetchData()), [fetchData, setService]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default useCustomerDetailService;
